import { rutWithNumbers, formatMoneyWithCurrency } from "../../utils/formatter";
import {
  getDocumentsAvailablePayableTotal,
  getDocumentsDelayedAvailablePayableTotal,
} from "../../utils/nominaAmounts";

export const totalToPay = (DTEs) => {
  const toPay = getDocumentsAvailablePayableTotal(DTEs);
  return formatMoneyWithCurrency(toPay);
};

export const delayedDTES = (DTEs) => {
  const delayed = getDocumentsDelayedAvailablePayableTotal(DTEs);
  return formatMoneyWithCurrency(delayed);
};

export const selectedDTEs = (DTEs) => {
  const selected = DTEs?.reduce(
    (acc, item) => (item?.selected ? acc + item.amountSelected : acc + 0),
    0
  );
  return formatMoneyWithCurrency(selected);
};

export const selectNominas = async (
  data,
  value,
  dispatch,
  importAlertState,
  selectAllNominasPartial,
  companyId,
  importUpdateNeeded,
  all = false,
) => {
  if (all) dispatch(
    importAlertState({
      content: "Estamos actualizando sus datos, por favor espere",
      state: "loading",
      duration: 5,
    })
  );
  const result = await selectAllNominasPartial({
    all,
    companyId,
    idProvider: data.rut,
    selected: value,
  });

  if (result.data) {
    if (all) dispatch(
      importAlertState({
        content: "Datos actualizados correctamente",
        state: "success",
        duration: 3,
      })
    );
    dispatch(importUpdateNeeded({ value: true }));
  }
  if (result.error) {
    dispatch(
      importAlertState({
        content:
          "Ha ocurrido un error en la operación, por favor vuelva a intentarlo más tarde",
        state: "error",
        duration: 5,
      })
    );
  }

  return result
};

export const exclude = async (
  data,
  dispatch,
  importAlertState,
  excludeProvider,
  companyId,
  importUpdateNeeded
) => {
  dispatch(
    importAlertState({
      content: "Estamos actualizando sus datos, por favor espere",
      state: "loading",
      duration: 5,
    })
  );
  const result = await excludeProvider({
    input: {
      companyId,
      provider: {
        name: data.name,
        rut: data.rut,
      },
      selected: true,
    },
  });
  if (result.data) {
    /*     dispatch(
          importAlertState({
            content: "Datos actualizados correctamente",
            state: "success",
            duration: 3,
          })
        ); */
    dispatch(importUpdateNeeded({ value: true }));
  }
  if (result.error) {
    dispatch(
      importAlertState({
        content:
          "Ha ocurrido un error en la operación, por favor vuelva a intentarlo más tarde",
        state: "error",
        duration: 5,
      })
    );
  }
};

export const newFilterNomina = ({ Nomina, filters }) => {
  const {
    name,
    rut,
    documentId,
    documentType,
    startDate,
    endDate,
    minDocument,
    maxDocument,
    minProvider,
    maxProvider,
    vigente,
    vencido,
    EERRAreas,
    cashflowAreaId,
  } = filters;
  
  if (!Object.values(filters).some((s) => s !== null)) return Nomina;

  if (!Nomina) return [];

  if (name) {
    Nomina = Nomina.filter((f) => f.name.toLowerCase().match(new RegExp(name.toLowerCase(), "g")));
  }

  if (rut) {
    Nomina = Nomina.filter((f) => {
      return rutWithNumbers(f?.providerRut?.toLowerCase()).match(
        new RegExp(rutWithNumbers(rut.toLowerCase()), "g")
      )
    }
    );
  }

  if (minProvider) {
    Nomina = Nomina.filter(
      (f) => f?.documents?.reduce((da, d) => da + d.amount, 0) >= minProvider
    );
  }

  if (maxProvider) {
    Nomina = Nomina.filter(
      (f) => f?.documents?.reduce((da, d) => da + d.amount, 0) <= maxProvider
    );
  }

  if (documentId) {
    Nomina = Nomina.filter((prov) => {
      const documentToFilter = documentId.split(";").filter((f) => f)
      return prov?.documents.some((item) => documentToFilter?.find((element) => item?.documentId?.toString()?.toLowerCase()?.includes(element?.toLowerCase()?.replaceAll(" ", ""))))
    }).map((item) => {
      const documentToFilter = documentId.split(";").filter((f) => f)
      const documentsFiltered = item?.documents.filter((f) => documentToFilter?.find((element) => f?.documentId?.toString()?.toLowerCase()?.includes(element?.toLowerCase()?.replaceAll(" ", ""))))
      return { ...item, documents: documentsFiltered }
    })
  }

  if (minDocument) {
    Nomina = Nomina.filter((prov) => prov?.documents?.some((f) => f.amount >= minDocument))
      .map((element) => {
        const filteredDocs = element?.documents?.filter((f) => f.amount >= minDocument)
        return { ...element, documents: filteredDocs }
      })
  }

  if (maxDocument) {
    Nomina = Nomina.filter((prov) => prov?.documents?.some((f) => f.amount <= maxDocument))
      .map((element) => {
        const filteredDocs = element?.documents?.filter((f) => f.amount <= maxDocument)
        return { ...element, documents: filteredDocs }
      })
  }

  if (vencido) {
    Nomina = Nomina.filter((prov) => prov?.documents?.some((f) => f?.daysToExpire <= 0))
      .map((element) => {
        const filteredDocs = element?.documents?.filter((f) => f.daysToExpire <= 0)
        return { ...element, documents: filteredDocs }
      })
  }

  if (vigente) {
    Nomina = Nomina.filter((prov) => prov?.documents?.some((f) => f?.daysToExpire > 0))
      .map((element) => {
        const filteredDocs = element?.documents?.filter((f) => f.daysToExpire > 0)
        return { ...element, documents: filteredDocs }
      })
  }

  if (startDate || endDate) {
    const normalizeDate = (date) => {
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      return d.getTime();
    };

    const minDate = startDate ? normalizeDate(startDate) : null;
    const maxDate = endDate ? normalizeDate(endDate) : null;
    
    Nomina = Nomina
      .map((prov) => {
        const filteredDocs = prov?.documents?.filter((dte) => {
          const emition = normalizeDate(dte.emition);
          if (minDate && maxDate) {
            return emition >= minDate && emition <= maxDate;
          } else if (minDate) {
            return emition >= minDate;
          } else if (maxDate) {
            return emition <= maxDate;
          }
          return true;
        }) || [];
      
        return filteredDocs.length > 0 ? { ...prov, documents: filteredDocs } : null;
      })
      .filter(Boolean);
  }

  if (documentType) {
    Nomina = Nomina.filter((prov) => prov?.documents?.some((s) => s?.documentCode?.toString()?.toLowerCase()?.includes(documentType?.toLowerCase())))
      .map((element) => {
        const documentFiltered = element?.documents?.filter((f) => f?.documentCode?.toString()?.toLowerCase()?.includes(documentType?.toLowerCase()))
        return { ...element, documents: documentFiltered }
      })
  }

  if (EERRAreas) {
    Nomina = Nomina.filter((prov) => prov?.documents?.some((s) => s.fieldKey === EERRAreas))
  }

  if (cashflowAreaId) {
    Nomina = Nomina.filter((prov) => prov?.documents?.some((s) => s.cashflowAreaId === cashflowAreaId))
  }

  const nominasConDocumentos = Nomina.filter((f) => {
    return f.documents && f.documents.length > 0;
  });
  return nominasConDocumentos

}

export function filterNominas(Nomina = [], filters = {}) {
  const {
    name,
    rut,
    documentId,
    documentType,
    startDate,
    endDate,
    minDocument,
    maxDocument,
    minProvider,
    maxProvider,
    vigente,
    vencido,
  } = filters;

  if (!Object.values(filters).some((s) => s !== null)) return Nomina;

  if (!Nomina) return [];
  if (name)
    Nomina = Nomina.filter((f) =>
      f.name.toLowerCase().match(new RegExp(name.toLowerCase(), "g"))
    );
  if (rut)
    Nomina = Nomina.filter((f) => {
      return rutWithNumbers(f?.providerRut?.toLowerCase()).match(
        new RegExp(rutWithNumbers(rut.toLowerCase()), "g")
      )
    }
    );
  if (minProvider)
    Nomina = Nomina.filter(
      (f) => f["documents"].reduce((da, d) => da + d.amount, 0) >= minProvider
    );
  if (maxProvider)
    Nomina = Nomina.filter(
      (f) => f["documents"].reduce((da, d) => da + d.amount, 0) <= maxProvider
    );

  if (
    minDocument ||
    maxDocument ||
    startDate ||
    endDate ||
    documentId ||
    documentType ||
    vigente ||
    vencido
  )
    Nomina = Nomina.map((prov) => {
      if (minDocument)
        prov["documents"] = prov["documents"].filter((d) => d.amount >= minDocument);
      if (maxDocument)
        prov["documents"] = prov["documents"].filter((d) => d.amount <= maxDocument);
      if (vigente)
        prov["documents"] = prov["documents"].filter((f) => f.daysToExpire > 0);
      if (vencido)
        prov["documents"] = prov["documents"].filter((f) => f.daysToExpire <= 0);

      if (startDate && endDate) {
        prov["documents"] = prov["documents"].filter((d) => {
          const expiration = new Date(d.emition).getTime();
          const minDate = new Date(startDate).getTime();
          const maxDate = new Date(endDate).getTime();
          return expiration >= minDate && expiration <= maxDate;
        });
      }
      if (documentId) {
        const documentToFilter = documentId.split(";").filter((f) => f)
        prov["documents"] = prov["documents"].filter((f) =>
          documentToFilter.find((element) => f?.documentId?.toString().toLowerCase()
            .includes(element.toLowerCase().replaceAll(" ", "")))
        );
      }
      if (documentType) {
        prov["documents"] = prov["documents"].filter((f) => {
          const documentCode = f.documentCode
          return documentCode.toString().toLowerCase().includes(documentType.toLowerCase())
        }
        );
      }

      return prov;
    });

  Nomina = Nomina.filter((f) => f["documents"].length > 0);

  return Nomina;
}

export const isInform = (providers) => {

  if (!providers.length) return false

  const dteInform = providers?.map((prov, index) => {
    return prov?.DTEs?.some((inform) => {
      return inform?.inform?.isInform;
    });
  });
  const showAlert = dteInform?.some((element) => element);
  return showAlert;
};

export const inAgenda = (providers) => {

  if (!providers.length) return false

  const inAgenda = providers?.some((provider) => !provider?.inAgenda);
  return inAgenda;
};

export const validateFields = async (json, companyId, callback) => {
  for (let i = 0; i < json.length; i++) {
    const element = json[i];
    if (element["nomina"] !== "MANUAL") {
      if (element["id"] === "undefined")
        return { message: "Nombre", valido: false, fila: i + 2 };
      if (element["name"] === "undefined")
        return { message: "Nombre", valido: false, fila: i + 2 };
      if (element["rut"] == "undefined")
        return { message: "Rut", valido: false, fila: i + 2 };
      if (element["Ndoc"] == "undefined")
        return { message: "N° de doc", valido: false, fila: i + 2 };
      if (element["tipo"] == "undefined")
        return { message: "Tipo", valido: false, fila: i + 2 };
      if (element["fecha"] == "undefined")
        return { message: "Fecha", valido: false, fila: i + 2 };
      if (element["vence"] == "undefined")
        return { message: "Vence en", valido: false, fila: i + 2 };
      if (element["monto"] == "undefined")
        return { message: "Monto", valido: false, fila: i + 2 };
      try {
        await callback({
          companyId,
          selected: element["pagar"],
          ids: element["id"],
        });
      } catch (error) {
        console.error(error);
      }
    }
  }
  return { valido: true };
};

export const convertJSONToInput = (json) =>
  json.map((row) => {
    return {
      id: row["Id"] !== undefined ? row["Id"] : "undefined",
      nomina: row["Nomina"],
      enAgenda:
        row["En Agenda"] !== undefined
          ? row["En Agenda"] === "si"
            ? true
            : false
          : "undefined",
      rut:
        row["Rut"] !== undefined
          ? typeof row["Rut"] === "string"
            ? row["Rut"].replace(/\./g, "").replace(/-/g, "")
            : row["Rut"].toString()
          : "undefined",
      name: row["Nombre"] !== undefined ? row["Nombre"] : "undefined",
      Ndoc:
        row["N° de Doc"] !== undefined
          ? row["N° de Doc"].toString()
          : "undefined",
      tipo: row["Tipo"] !== undefined ? row["Tipo"] : "undefined",
      fecha: row["Fecha"] !== undefined ? row["Fecha"] : "undefined",
      vence:
        row["Vence en"] !== undefined
          ? row["Vence en"].toString()
          : "undefined",
      monto: row["Monto"] !== undefined ? row["Monto"].toString() : "undefined",
      pagar:
        row["Seleccionar (Marcar con x)"] === "X" ||
          row["Seleccionar (Marcar con x)"] === "x"
          ? true
          : false,
    };
  });
